import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { config } from "../../services/configHeader";

const baseUrl = process.env.REACT_APP_BASE_URI;

let initialState = {
    monthAttLoading: false,
    monthAttSuccess: false,
    monthAttError: false,
    monthAttMessage: null,

    monthAttGetLoading: false,
    monthAttGetSuccess: false,
    monthAttGetError: false,
    monthAttGetMessage: null,
    monthAttGetData: null,
};

const user = localStorage.getItem("user_data")
    ? JSON.parse(localStorage.getItem("user_data"))
    : null;
const userId = user?.user_id;
const accountType = user?.account_type;

export const fetchMonthAttData = createAsyncThunk("fetchMonthAttData", async (body) => {
    const { path, data } = body
    return await axios
        .post(`${baseUrl}${path}`, data, config)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            if (!navigator.onLine) {
                let data = {
                    response: {
                        data: [],
                        message: "No Internet Connection Found",
                        success: false,
                    },
                    data: {
                        data: [],
                        message: "No Internet Connection Found",
                        success: false,
                    },
                }
                return data
            } else {
                return error
            }

        });
});

export const saveMonthAtt = createAsyncThunk("saveMonthAtt", async (data) => {
    const result = {
        data: {
            message: "Sorry, you can only view the data, not create it.",
            data: [],
        },
    };

    return parseInt(accountType) === 2
        ? result
        : await axios
            .post(`${baseUrl}admin/createBranch`, data, config)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                if (!navigator.onLine) {
                    alert('You are offline. Please check your internet connection.');
                } else {
                    alert('An error occurred. Please try again later.');
                }
                let data = {
                    response: {
                        data: [],
                        message: "No Internet Connection Found",
                        success: false
                    },
                }
                return data
            });
});

const monthAttendanceSlice = createSlice({
    name: "monthAttendance",
    initialState,

    reducers: {
        initMonthState: (state) => {
            state.monthAttLoading = false;
            state.monthAttSuccess = false;
            state.monthAttError = false;
            state.monthAttMessage = null;
        },
        initMonthAttState: (state) => {
            state.monthAttGetLoading = false;
            state.monthAttGetSuccess = false;
            state.monthAttGetError = false;
            state.monthAttGetMessage = null;
        },
    },

    extraReducers: (builder) => {
        builder.addCase(fetchMonthAttData.pending, (state, action) => {
            state.monthAttGetLoading = true;
            state.monthAttGetSuccess = false;
            state.monthAttGetError = false;
            state.monthAttGetMessage = null;
            state.monthAttGetData = null;
        });
        builder.addCase(fetchMonthAttData.fulfilled, (state, action) => {
            state.monthAttGetLoading = false;
            state.monthAttGetSuccess = true;
            state.monthAttGetError = false;
            state.monthAttGetMessage = action.payload.data;
            state.monthAttGetData = action.payload.data;
        });
        builder.addCase(fetchMonthAttData.rejected, (state, action) => {
            state.monthAttGetLoading = false;
            state.monthAttGetSuccess = false;
            state.monthAttGetError = true;
            state.monthAttGetMessage = action.payload.data.message;
            state.monthAttGetData = null;
        });
        // To create branch
        builder.addCase(saveMonthAtt.pending, (state, action) => {
            state.monthAttLoading = true;
            state.monthAttSuccess = false;
            state.monthAttError = false;
            state.monthAttMessage = null;
        });
        builder.addCase(saveMonthAtt.fulfilled, (state, action) => {
            state.monthAttLoading = false;
            state.monthAttSuccess = accountType == 2 ? false : true;
            state.monthAttError = accountType == 2 ? true : false;
            state.monthAttMessage = action.payload.data.message;
        });
        builder.addCase(saveMonthAtt.rejected, (state, action) => {
            state.monthAttLoading = false;
            state.monthAttSuccess = false;
            state.monthAttError = true;
            state.monthAttMessage = action.payload.data.message;
        });
    },
});

export const { initMonthState, initMonthAttState } = monthAttendanceSlice.actions;

export default monthAttendanceSlice.reducer;
